import Vue from 'vue'

Vue.filter('withBaseUrl', function (value) {
  if (!value) return ''
  // TODO: This will be used in kubernetes pods. Use env variable
  // return process.env.STATIC_URL + value
  return Vue.axios.defaults.baseURL.replace('/api', '') + value
})

Vue.filter('titlize', function (value) {
  var stringArray = value.split(' ')
  stringArray = stringArray.map(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  })
  return stringArray.join(' ')
})



// WEBPACK FOOTER //
// ./src/components/mixins/filters.js